import React from "react";

// Extension de marque par pays (code ISO en minuscules). Neutre "SuccèsNet" si aucun pays.
export const brandExt = (country) => (country ? `.${String(country).toLowerCase()}` : "");
export const brandName = (country) => `SuccèsNet${brandExt(country)}`;

export function Brand({ country, accentClass = "text-[#E85D04]", className = "" }) {
  const ext = brandExt(country);
  return (
    <span className={`font-display font-extrabold ${className}`} data-testid="brand-name">
      SuccèsNet{ext && <span className={accentClass}>{ext}</span>}
    </span>
  );
}
